import { isDefined, isNonEmptyString } from 'ts-utils';
import { AppSelector, store } from '../store/Store';

/** @throws if the Entry has no ASL payment-link id */
export function getAslPaymentLink(): string {
  const state = store.getState();
  const { userId, email } = AppSelector.user(state);
  const paymentLinkId = state.entry.aslPaymentLinkId;

  if (!isDefined(userId)) {
    throw new Error('userId not defined for ASL payment link');
  }
  if (!isNonEmptyString(paymentLinkId)) {
    throw new Error('paymentLinkId is undefined or empty for ASL payment link');
  }

  return `https://buy.stripe.com/${paymentLinkId}?client_reference_id=${userId}&locked_prefilled_email=${email}`;
}
